import { ref, Ref } from 'vue';
import { Annotation } from '../types/annotation.types';

export function useAnnotationApproval(
  annotation: Ref<Annotation>,
  saveAnnotationApproval: (params: { annotation: Annotation; approved: number }) => Promise<any>
) {
  const isNotApproved = ref<boolean>(false);

  const processAnnotationApproval = async (approved: number) => {
    try {
      const res = await saveAnnotationApproval({
        annotation: annotation.value,
        approved,
      });

      if (res?.approved === 0) {
        isNotApproved.value = true;
      } else {
        isNotApproved.value = false;
      }

      if (res) {
        annotation.value.approved = res.approved;
      }

      return res;
    } catch (error) {
      console.error('Error processing annotation approval:', error);
      throw error;
    }
  };

  const doApprove = async () => {
    const approval =
      annotation.value.approved === undefined || annotation.value.approved <= 0 ? 1 : 0;
    return await processAnnotationApproval(approval);
  };

  const doDisapprove = async () => {
    const approval =
      annotation.value.approved === undefined || annotation.value.approved >= 0 ? -1 : 0;
    return await processAnnotationApproval(approval);
  };

  return {
    isNotApproved,
    doApprove,
    doDisapprove,
    processAnnotationApproval,
  };
}
